import { EventEmitter, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
var noop = function () {
};
var ɵ0 = noop;
export var CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return CustomSelectComponent; }),
    multi: true
};
var CustomSelectComponent = /** @class */ (function () {
    function CustomSelectComponent() {
        this.onTouchedCallback = noop;
        this.onChangeCallback = noop;
        // -------------- Component features ----------------- //
        this.isOpened = false;
        this.onOpen = new EventEmitter();
        this.onClose = new EventEmitter();
        this.onSelect = new EventEmitter();
    }
    Object.defineProperty(CustomSelectComponent.prototype, "option", {
        get: function () {
            return this._option;
        },
        set: function (v) {
            if (v !== this._option) {
                this._option = v;
                this.onChangeCallback(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    CustomSelectComponent.prototype.writeValue = function (value) {
        if (value !== this._option) {
            this._option = value;
        }
    };
    CustomSelectComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    CustomSelectComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    CustomSelectComponent.prototype.ngOnChanges = function (changes) {
        if (this.options != null) {
            var size_1 = this.options.length;
            var optionSelected = this.options.find(function (option) {
                return option.selected == true || size_1 == 1;
            });
            if (optionSelected != null) {
                this.placeholder = optionSelected.name;
                this.option = optionSelected;
            }
        }
    };
    CustomSelectComponent.prototype.toggleSelect = function ($event) {
        this.isOpened = !this.isOpened;
        if (this.isOpened) {
            this.onOpen.emit();
        }
        else {
            this.onClose.emit();
        }
    };
    CustomSelectComponent.prototype.selectOption = function (item) {
        this.options.forEach(function (opt) {
            opt.selected = false;
        });
        item.selected = true;
        this.option = item;
        this.isOpened = false;
        this.placeholder = item.name;
        this.onSelect.emit(item);
    };
    return CustomSelectComponent;
}());
export { CustomSelectComponent };
export { ɵ0 };
